module.exports = __webpack_public_path__ + "static/media/fr.5dca2149.svg";